
//路由层
const View = resolve => require(["../../components/View.vue"], resolve);


/**
 *   内容管理器 （装修/个性化）路由表
 */
const decorationRouter = {
  path: 'decoration',
  name: "个性化",
  component: View,
  children: [
    {
      path: "index",
      component: () => import("@/view/decoration/index"),
      name: "系统管理/个性化"
    },
  ]
};

export default decorationRouter;



// WEBPACK FOOTER //
// ./src/router/modules/decoration.js